import React from 'react';
import { Star, Shield, Lock, CreditCard } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Pasé de desabrocharme el pantalón después de almorzar a sentirme liviana todo el día. Con el Protocolo Reset entendí lo del CMM y todo cambió. Recuperé la confianza para salir a cenar con mi pareja sin miedo.',
    name: 'Laura M.',
    age: '44 años',
    photo: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Por fin un método que me permite comer chocolate y seguir bajando centímetros de cintura. Mi digestión está en paz y mi energía está por las nubes.',
    name: 'Sonia G.',
    age: '52 años',
    photo: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Los Elixires de Mañana me ahorraron horas de cocina. Ya no llego cansada a la tarde. Mi metabolismo realmente se reseteó.',
    name: 'Marta R.',
    age: '47 años',
    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Mi pareja notó el cambio en mi humor y mi piel antes que yo misma. Me veo más radiante y con energía.',
    name: 'Carla S.',
    age: '41 años',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Invertí $7.49 esperando poco y recibí el mapa más completo de mi vida. Los resultados hablan solos.',
    name: 'Elena F.',
    age: '49 años',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face'
  }];
  return <section className="py-10 bg-transparent" data-id="element-528">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-529">
        <div className="max-w-5xl mx-auto" data-id="element-530">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-sage text-center mb-8 leading-tight" data-id="element-531">
            Lo que dicen quienes ya usan el Protocolo Vientre Plano 40+
          </h2>

          <div className="grid md:grid-cols-2 gap-5 mb-10" data-id="element-532">
            {testimonials.map((t, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-sage/5" data-id="element-533">
                <div className="flex items-center gap-3 mb-3" data-id="element-534">
                  <img src={t.photo} alt={t.name} className="w-11 h-11 rounded-full object-cover flex-shrink-0 border-2 border-gold/30" data-id="element-535" />
                  <div className="flex gap-0.5" data-id="element-536">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-537" />)}
                  </div>
                </div>

                <p className="text-sage/80 leading-relaxed mb-4 text-[15px]" data-id="element-538">
                  "{t.text}"
                </p>

                <p className="font-bold text-sage text-sm" data-id="element-539">
                  {t.name}{' '}
                  <span className="font-normal text-sage/60" data-id="element-540">({t.age})</span>
                </p>
              </div>)}
          </div>

          {/* Guarantee */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-sage/10 flex items-start gap-5 max-w-2xl mx-auto" data-id="element-541">
            <Shield className="w-10 h-10 text-gold flex-shrink-0 mt-1" data-id="element-542" />
            <div data-id="element-543">
              <h4 className="font-serif font-bold text-sage text-lg mb-2" data-id="element-544">
                Garantía "Vientre Liviano" de 7 Días — Riesgo Cero Absoluto
              </h4>
              <p className="text-sage/70 leading-relaxed" data-id="element-545">
                Aplicá el Protocolo durante 7 días completos. Si no sentís que
                tu digestión mejoró, que tu ropa te queda diferente y que tu
                energía subió, te devolvemos el 100% de tu dinero. Sin
                preguntas. Sin formularios. Sin demoras. Nosotras asumimos todo
                el riesgo porque confiamos en lo que construimos. Vos solo
                perdés la hinchazón.
              </p>
            </div>
          </div>

          {/* Trust icons */}
          <div className="flex items-center justify-center gap-8 mt-6 text-sage/40 text-sm" data-id="element-546">
            <div className="flex items-center gap-2" data-id="element-547">
              <Lock className="w-4 h-4" data-id="element-548" /> Pago Seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-549">
              <CreditCard className="w-4 h-4" data-id="element-550" /> Todas las tarjetas
            </div>
          </div>
        </div>
      </div>
    </section>;
}